import { fetchFromRTM } from './index';
import * as constants from './constants';

const normalizeLibraryItem = (item) => ({
  activityId: item.activityId,
  cohortId: item.cohortId,
  deploymentId: item.deploymentId,
  title: item.title || item.name || item.activityTitle || '',
  type: item.type,
});

const extractLibraryItems = (response) => {
  if (!response) {
    return [];
  }

  if (Array.isArray(response)) {
    return response;
  }

  return response.libraries
    || response.library
    || response.deployments
    || response.activities
    || response.items
    || [];
};

class LibraryResolver {
  constructor(connection) {
    this.connection = connection;
  }

  /**
   * Fetch library-designated courseware via workspace.library.list WebSocket RTM.
   * @returns {Promise<Array<{activityId: string, cohortId: string, deploymentId: string, title: string, type: string}>>}
   */
  workspaceLibraryList = async () => {
    const message = {
      type: constants.RTM_WORKSPACE_LIBRARY_LIST,
    };

    const response = await fetchFromRTM(
      this.connection,
      message,
      constants.RTM_WORKSPACE_LIBRARY_LIST_OK,
      constants.RTM_WORKSPACE_LIBRARY_LIST_ERROR,
    );

    const items = extractLibraryItems(response);

    return Array.isArray(items) ? items.map(normalizeLibraryItem) : [];
  };
}

export default LibraryResolver;
